<template>
    <inline-tab-panel name="tasks">
        <flex-container>
            <flex-container :gap="Size.sm" align-items="center">
                <text-heading>
                    Taken
                </text-heading>

                <chip-informative :color="'primary'">
                    {{ props.taskCollection.total }}
                </chip-informative>
            </flex-container>

            <card-normal without-padding>
                <list-container fixed>
                    <template #header>
                        <list-cell-header :width="10">
                            <template #title>
                                Datum
                            </template>
                        </list-cell-header>
                        <list-cell-header :width="10">
                            <template #title>
                                Tijd
                            </template>
                        </list-cell-header>
                        <list-cell-header :width="10">
                            <template #title>
                                Soort
                            </template>
                        </list-cell-header>
                        <list-cell-header :width="20">
                            <template #title>
                                Met
                            </template>
                        </list-cell-header>
                        <list-cell-header :width="50">
                            <template #title>
                                Laatste notitie
                            </template>
                        </list-cell-header>
                    </template>

                    <template #content>
                        <list-row v-if="sortedTasks.length === 0">
                            <list-cell-text colspan="6">
                                <template #content>
                                    Er zijn geen taken voor dit contact
                                </template>
                            </list-cell-text>
                        </list-row>
                        <list-row
                            v-for="(task, index) in sortedTasks"
                            :key="task.id.value"
                            :background-color="index % 2 ? 'gray-100' : 'white'"
                        >
                            <list-cell-text>
                                <template #content>
                                    {{ formatDate(task.dueDateTime) }}
                                </template>
                            </list-cell-text>
                            <list-cell-text>
                                <template #content>
                                    {{ formatTime(task.dueDateTime) }}
                                </template>
                            </list-cell-text>
                            <list-cell-text>
                                <template #content>
                                    {{ task.typeLabel ?? '-' }}
                                </template>
                            </list-cell-text>
                            <list-cell-text>
                                <template #content>
                                    {{ task.assignedUsers.map((user) => user.name.fullName).join(', ') }}
                                </template>
                            </list-cell-text>
                            <list-cell-text>
                                <template
                                    v-if="task.comment"
                                    #content
                                >
                                    <read-more-modal :text="task.comment" />
                                </template>
                                <template
                                    v-else
                                    #content
                                >
                                    <chip-informative>Geen notitie</chip-informative>
                                </template>
                            </list-cell-text>
                        </list-row>
                    </template>
                </list-container>
            </card-normal>
        </flex-container>
    </inline-tab-panel>
</template>

<script setup lang="ts">
    import { formatDate, formatTime } from '@/shared/utils/date';
    import type { ReactiveCollection } from '@/services/keyvue-api/composables/useClient';
    import type { Task } from '@keyvue/one-api-client';
    import { ListRow, Size } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import ReadMoreModal from '@/shared/components/ReadMoreModal.vue';

    const props = defineProps<{
        taskCollection: ReactiveCollection<Task>
    }>();

    const sortedTasks = computed(() => (
        [...props.taskCollection.data.value].sort((a, b) => (b.dueDateTime.getTime() - a.dueDateTime.getTime()))
    ));
</script>
